"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleSearchConfig = void 0;
exports.googleSearchConfig = {
    hostedDomain: 'newfront.com',
    queryScope: 'https://www.googleapis.com/auth/cloud_search.query',
    googleApiScriptSourceUrl: 'https://apis.google.com/js/api.js?mods=enable_cloud_search_widget&onload=onGoogleCloudSearchApiLoad',
};
